import { useLayoutEffect, useState } from "react";
import styled from "styled-components";

export const Container = styled.div`
  padding: 30px 0;
  width: 100%;
  max-width: 100%;
`;
export const ContainerV2 = styled.div`
`;
export const ContainerAuth = styled.div`
  @media screen and (max-width: 1024px) {
    height: auto;
  }
`;
export const ContainerCenter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const ContainerRow = styled.div`
  display: flex;
  @media screen and (max-width: 1024px) {
    & {
      display:block;
    }
  }
`;
export const ContainerView = styled.div`
  margin: 34px auto 0;
  min-height: calc(100vh - 456px);
  width: 100%;
  margin: 0 auto;
  z-index: 10;
  padding: 0 15px;
  max-width: 100%;
  &.no-height{
    min-height: unset;
  }
  &.min-height-385{
    min-height: 385px;
  }
  @media screen and (min-width: 768px) {
    padding-left: 30px;
    padding-right: 30px;
  }
  @media screen and (min-width: 1280px) {
    padding-left: 40px;
    padding-right: 40px;
  }
  @media screen and (min-width: 1440px) {
    padding-left: 60px;
    padding-right: 60px;
  }
  @media screen and (min-width: 1536px) {
    padding-left: 80px;
    padding-right: 80px;
  }
  @media screen and (min-width: 1920px) {
    padding-left: 105px;
    padding-right: 105px;
    max-width: 1920px;
  }
`;

export const ContainerViewStake = styled.div`
  min-height: 400px;
  width: 100%;
  margin: 0 auto;
  z-index: 10;
  padding: 0 10px;
  max-width: 800px;
`;

export const TitlePage = styled.div`
  font-weight: 600;
  font-size: 34px;
  line-height: 42px;
  letter-spacing: -0.04em;
  text-transform: capitalize;
  color: #000000;
  @media screen and (max-width: 1024px) {
    font-size: 24px;
    line-height: 28px;
  }
`;

export const Popup = (props) => {};

export const DesktopContainer = (props) => {
  const [isVisible, setIsVisible] = useState(window.innerWidth > 1024);
  useLayoutEffect(() => {
    function updateSize() {
      setIsVisible(window.innerWidth > 1024);
    }

    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  return isVisible ? props.children : null;
};

export const MobileContainer = (props) => {
  const [isVisible, setIsVisible] = useState(window.innerWidth <= 1024);
  useLayoutEffect(() => {
    function updateSize() {
      setIsVisible(window.innerWidth <= 1024);
    }

    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  return isVisible ? props.children : null;
};
